$(document).ready(function(){

  // lazy loads elements with default selector as '.lozad'
  const observer = lozad();
  observer.observe();
	
	 $('#main-photo ul').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '#mini-photos ul'
	});
	$('#mini-photos ul').slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
      vertical: false,
	  asNavFor: '#main-photo ul',
	  dots: false,
	  arrows: false,
	  centerMode: true,
    lazyLoad: 'ondemand',
	  focusOnSelect: true,
      responsive: [
        {
          breakpoint: 830,
          settings: {
            vertical: false,
            slidesToShow: 4,
            slidesToScroll: 1,
			centerMode: false,
          }
        }
      ]
	});
	
	
	// Header
	
	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
  
    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});
	
	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');	
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');	
	});
	
	$('header .show-menu').click(function(){
		$('nav').addClass('show');
	});
	$('header nav .cerrar').click(function(){
		$('nav').removeClass('show');	
	});

  	// Product
  
    $('.featured-collection ul .item[data-id="4664968183867"]').remove();
    $('.featured-collection ul .item[data-id="4664956551227"]').remove();

    $('.product .right .deon > h3').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .right .deon h3').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });
  
    var winW = $(window).width();
  
    if ( winW < 830 ) {
      $('li.site-nav--has-dropdown > a').removeAttr('href');
      
      $('nav ul.menu > li.site-nav--has-dropdown > a').click(function(){
        $(this).parent().siblings().children('.sub-menu').removeClass('show');
        $(this).parent().children('.sub-menu').toggleClass('show');
      });
      
      $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown > a').click(function(){
        $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
        $(this).parent().children('.sub-sub-menu').toggleClass('show');
      });
    }
  
  
    // Pop Up  
  
    $('#popup .cerrar').click(function(){
      $('#popup').removeClass('show');
    });

    //$('#popup').addClass('show');

    if (!Cookies.get('showed_newsletter')) {
      setTimeout(function(){
        $('#popup').addClass('show');
        Cookies.set('showed_newsletter', 'true', { expires: 7 });
      },2000) // 3 seconds.
    }
	
    update_mini_cart(false, true);

});


/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      let precioun     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      let precio     = data.items[i]["line_price"] ? parseFloat(data.items[i]["line_price"]).toString().substring(0, parseFloat(data.items[i]["line_price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var alt        = data.items[i]["featured_image"]["alt"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img class='lozad' src='" + imagen + "' alt='" + alt + "' loading='lazy' /></div></li>";
      console.log({ precio });
      console.log({ precioun });
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").html('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}